import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Seo } from "../components/Seo";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/motion";
import { BUSINESS, FAQS, restaurantLd, breadcrumbLd } from "../data/business";

const faqLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqPage() {
  return (
    <>
      <Seo
        title="FAQ Bakso Tujuh Pemuda — Pertanyaan yang Sering Diajukan"
        description="Jawaban seputar Bakso Tujuh Pemuda Bogor: lokasi, jam buka, daftar menu dan harga, sertifikasi halal, reservasi WhatsApp, serta pesan antar online."
        path="/faq/"
        jsonLd={[restaurantLd, faqLd, breadcrumbLd([{ name: "Beranda", path: "/" }, { name: "FAQ", path: "/faq/" }])]}
      />
      <PageHeader
        crumb="FAQ"
        eyebrow="Sebelum mampir"
        lines={[<>Pertanyaan yang <span className="italic font-semibold text-terracotta">sering diajukan</span></>]}
      />
      <section className="py-16 sm:py-24" data-testid="faq-page">
        <div className="max-w-3xl mx-auto px-4">
          <Reveal>
            <Accordion type="single" collapsible className="space-y-3">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="bg-white border border-line rounded-2xl px-5 overflow-hidden"
                >
                  <AccordionTrigger className="text-left font-display font-bold text-base sm:text-lg py-5 hover:text-terracotta hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-ink-soft leading-relaxed pb-5">{f.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-12 text-center">
              <p className="text-ink-soft">Masih ada pertanyaan? Kami senang menjawabnya.</p>
              <div className="mt-5 flex flex-wrap justify-center gap-3">
                <a
                  href={BUSINESS.links.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="whatsapp-reservation-button"
                  className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-terracotta text-cream font-bold hover:bg-terracotta-dark transition-colors duration-300"
                >
                  Tanya via WhatsApp
                </a>
                <Link to="/menu/" data-testid="faq-menu-link" className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-ink font-bold hover:bg-ink hover:text-cream transition-colors duration-300">
                  Lihat Menu
                  <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
